// extracted by mini-css-extract-plugin
export default {"form":"FormModal_form__0tSHM","centerItem":"FormModal_centerItem__xsWzR","questionContainer":"FormModal_questionContainer__ZdlP7","question":"FormModal_question__6OWdi"};